import { Navigate, useLocation } from 'react-router-dom';

import { Skeleton } from '../components/Skeleton';
import { useAuth } from './AuthProvider';
import styles from './RequireAuth.module.css';

/** Guard защищённых роутов: `/api/me` уже загружен, мигания логина нет. */
export function RequireAuth({ children }: { readonly children: JSX.Element }) {
  const { user, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className={styles['loading']}>
        <Skeleton variant="row" count={3} />
      </div>
    );
  }

  if (!user) {
    const next = encodeURIComponent(`${location.pathname}${location.search}`);
    return <Navigate to={`/login?next=${next}`} replace />;
  }

  // Пароль выдан администратором: до смены остальные API отвечают 403.
  if (user.mustChangePassword && location.pathname !== '/change-password') {
    return <Navigate to="/change-password" replace />;
  }

  return children;
}

/** Guard admin-разделов (UC-USR): Member получает 403 от API, здесь — редирект. */
export function RequireAdmin({ children }: { readonly children: JSX.Element }) {
  const { user, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className={styles['loading']}>
        <Skeleton variant="row" count={3} />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (user.role !== 'admin') {
    return <Navigate to="/" replace />;
  }

  return children;
}
